import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  tabs: JSON.parse(sessionStorage.getItem("tabs") || "{}") || undefined,
}
const tab = createSlice({
  name: "tab",
  initialState,
  reducers: {
    setTabs: (state, action) => {
      const key = action.payload.key;
      const value = action.payload.value;
      state.tabs = { ...state.tabs, [key]: value };
      sessionStorage.setItem("tabs", JSON.stringify(state.tabs));
    },

    resetTabs: (state) => {
      state.tabs = undefined;
      sessionStorage.removeItem("tabs");
    },
  
  },
});

export const { setTabs,  resetTabs } = tab.actions;
export default tab.reducer;